<template>
  <img alt="avatar" :src="imgSrc" v-bind="$attrs" v-on:error="onerror" />
</template>

<script>
function fallbackImg (vm) {
  return vm.$store.getters.getUserProfileImage()
}

export default {
  name: 'ProfileImage',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      imgSrc: this.src
    }
  },
  watch: {
    src (newValue, oldValue) {
      if (typeof oldValue !== 'undefined') {
        this.imgSrc = newValue
      }
    }
  },
  methods: {
    onerror () {
      this.imgSrc = fallbackImg(this)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProfileImage.vue